import { FC } from "react";
import Container from "@/components/Container";
import useMediaQuery from "@/custom_hooks/mediaQuery";
import main from "@/assets/images/longevity/telomera_clinics.png";
import howItWorks1 from "@/assets/images/longevity/how_it_works1.png";
import howItWorks2 from "@/assets/images/longevity/how_it_works2.png";
import howItWorks3 from "@/assets/images/longevity/how_it_works3.png";
// import cx from 'classnames';
// import classes from '@/pages/index.module.css';
import MediaList from "@/components/Media/MediaList";
import MediaSlider from "@/components/Media/MediaSlider";
import { COLLAPSABLE_CONTENT_GENOM_TEST_FAQ_VALUES_2 } from "@/components/Collapsible/constants";
import Collapsible1 from "@/components/Collapsible/index";
// import ButtonIcon from "@/components/UI/Buttons/ButtonIcon";
import NewsletterForm from "@/components/NewsletterForm";
// import { Link } from "react-router-dom";

const ClinicalStudy: FC = () => {
  const isMobile = useMediaQuery(768);

  return (
    <div className="flex flex-col md:mt-20">
      {/* Main Section */}
      <section className="flex flex-col px-4 md:px-6">
        <Container>
          <div className="grid gap-6 md:grid-cols-5">
            <h1 className="text-primary md:col-span-3">
              <span className="md:hidden">
                Susipažinkite su Telomera klinikine studija
              </span>
              <span className="hidden md:inline-block">
                Susipažinkite
                <br />
                su Telomera klinikine
                <br />
                studija
              </span>
            </h1>

            <div className="text-grey-100 md:text-grey-400 flex flex-col gap-[20px] md:col-span-2 md:text-lg">
              <p>
                Telomera vykdoma studija siekia įvertinti pasaulyje pripažinto
                ilgaamžiškumo eksperto dr. David Sinclair siūlomo maisto papildų
                protokolo poveikį biologiniam senėjimui ir pagrindiniams
                sveikatos rodikliams.
              </p>
              <p>
                Tikimasi, kad gauti rezultatai prisidės ne tik prie mokslo
                pažangos Lietuvoje, bet taps svarbiu indėliu Europos mastu
                vystant personalizuotos prevencijos kryptį.
              </p>
            </div>
          </div>

          <img
            src={main}
            alt="genų testas"
            className="my-12 aspect-[1.37/1] w-full rounded-[20px] object-cover md:aspect-auto"
          />
        </Container>
      </section>

      {/* How it works Section */}
      <section className="md:bg-grey-200 mb-8 flex flex-col px-4 md:mb-0 md:px-6">
        <Container>
          <h2 className="text-grey md:text-primary mb-8 md:mt-12 md:mb-10">
            Kokia tyrimo eiga?
          </h2>

          <div className="grid items-center md:grid-cols-2 md:gap-16">
            <div className="md:after:bg-grey-400 relative md:after:absolute md:after:top-1/2 md:after:-right-[40px] md:after:h-1/2 md:after:w-[1px] md:after:content-['']">
              <div className="md:mt-10 md:mr-10 md:mb-10">
                <img
                  src={howItWorks1}
                  alt="lady on sofa"
                  className="w-full rounded-[22px] md:max-w-[90%]"
                />
              </div>

              <div className="outline-grey-200 bg-primary text-grey-200 absolute top-1/2 -right-[70px] z-10 hidden h-16 w-16 -translate-y-1/2 items-center justify-center rounded-[8px] outline-6 md:mb-10 md:flex">
                <span className="text-[26px] font-semibold">1</span>
              </div>
            </div>

            <div className="flex justify-center md:hidden">
              <span className="text-grey-200 bg-primary mt-6 flex h-16 w-16 items-center justify-center rounded-[8px] text-[26px] font-semibold">
                1
              </span>
            </div>

            <div className="text-primary mt-6 flex flex-col gap-[16px] text-start md:mt-10 md:mb-10 md:pl-14">
              <h2>Kokia tyrimo eiga?</h2>
              <p className="md:text-[20px]">
                Tyrime dalyvauja 100 atrinktų asmenų. Pirmojo vizito metu
                serankami mėginiai genetikos, epigenetikos ir kraujo analizei.
              </p>
            </div>

            <div className="relative my-4 h-[98px] md:hidden">
              <div className="border-grey-400 absolute left-1/2 h-[98px] border-l"></div>
            </div>
          </div>

          <div className="grid items-center md:grid-cols-2 md:gap-16">
            <div className="flex justify-center md:hidden">
              <span className="text-grey-200 bg-primary mt-6 flex h-16 w-16 items-center justify-center rounded-[8px] text-[26px] font-semibold">
                2
              </span>
            </div>

            <div className="md:after:bg-grey-400 relative flex h-full flex-col justify-center text-start md:after:absolute md:after:top-0 md:after:-right-[40px] md:after:h-full md:after:w-[1px] md:after:content-['']">
              <div className="text-primary mt-6 flex flex-col gap-[16px] pb-5 md:mt-10 md:mb-10">
                <h2>Senėjimo preceso lėtinimo papildų protokolas</h2>
                <p className="md:text-[20px]">
                  25 asmenys įtraukiami į palyginamąją grupę, o 75 tiriamieji
                  tris mėnesius, kiekvieną dieną vartoja šiuos papildus:
                </p>
                <ul>
                  <li>NAD+ 500mg</li>
                  <li>Fisetinas 500mg</li>
                  <li>Resveratrolis 1000mg</li>
                  <li>Berberinas 1000mg</li>
                  <li>Kvercetinas 1000mg</li>
                </ul>
              </div>

              <div className="outline-grey-200 bg-primary text-grey-200 absolute top-1/2 -right-[70px] z-10 hidden h-16 w-16 -translate-y-1/2 items-center justify-center rounded-[8px] outline-6 md:flex">
                <span className="text-[26px] font-semibold">2</span>
              </div>
            </div>

            <div className="order-first flex md:order-last md:mt-10 md:mb-10 md:ml-10 md:justify-end">
              <img
                src={howItWorks2}
                alt="doctor"
                className="w-full rounded-[22px] md:max-w-[90%]"
              />
            </div>

            <div className="relative my-4 h-[98px] md:hidden">
              <div className="border-grey-400 absolute left-1/2 h-[98px] border-l"></div>
            </div>
          </div>

          <div className="grid items-center md:mb-16 md:grid-cols-2 md:gap-16">
            <div className="md:after:bg-grey-400 relative md:after:absolute md:after:top-0 md:after:-right-[40px] md:after:h-full md:after:w-[1px] md:after:content-['']">
              <div className="md:mt-10 md:mr-10">
                <img
                  src={howItWorks3}
                  alt="brain health"
                  className="w-full rounded-[22px] md:max-w-[90%]"
                />
              </div>

              <div className="outline-grey-200 bg-primary text-grey-200 absolute top-1/2 -right-[70px] z-10 hidden h-16 w-16 -translate-y-1/2 items-center justify-center rounded-[8px] outline-6 md:mt-10 md:flex">
                <span className="text-[26px] font-semibold">3</span>
              </div>
            </div>

            <div className="flex justify-center md:hidden">
              <span className="text-grey-200 bg-primary mt-6 flex h-16 w-16 items-center justify-center rounded-[8px] text-[26px] font-semibold">
                3
              </span>
            </div>

            <div className="text-primary mt-6 flex flex-col gap-[16px] text-start md:mt-10 md:pl-14">
              <h2>Tyrimų kartojimas ir rezultatų vertinimas</h2>
              <p className="md:text-[20px]">
                Po trijų mėnesių visiems tyrimo dalyviams kartojami
                epigenetiniai ir kraujo tyrimai bei stebimi biologinių žymenų
                pokyčiai.
              </p>
            </div>

            <div className="relative my-4 md:hidden">
              <div className="border-grey-400 absolute left-1/2 border-l"></div>
            </div>
          </div>

          {/* <div className="relative md:flex justify-center w-full my-20 flex">
                        <div className="border-l border-grey-400 absolute left-1/2 translate-x-[7px] -top-20 h-[98px] "></div>
                         <Link
                                to={`/ilgaamziskumo-programa`}
                         >
                         <ButtonIcon className="z-10 outline-6 outline-grey-200" iconWidth={24} iconHeight={24} label="Pradėkite kelionę šiandien" icon="arrow" theme="dark" />
                        </Link>
                    </div> */}
        </Container>
      </section>

      {/* Media Section */}
      <section className="mt-8 mb-12 px-4 md:px-6">
        <Container>
          <h2 className="text-grey md:text-primary mb-10">
            „Telomera žiniasklaidoje“ -<br />
            ekspertų įžvalgos ir straipsniai
          </h2>
          {!isMobile && <MediaList />}
          {isMobile && <MediaSlider />}
        </Container>
      </section>

      {/* FAQ Section */}
      <Collapsible1
        data={COLLAPSABLE_CONTENT_GENOM_TEST_FAQ_VALUES_2}
        theme="dark"
        variant="first"
        video={true}
      />

      {/* Newsletter form Section */}
      <section className="my-14 px-4 md:my-18 md:px-6">
        <Container>
          <NewsletterForm />
        </Container>
      </section>
    </div>
  );
};

export default ClinicalStudy;
